class GiftingView extends window.BAO.CustomElement({
  SuperClass: HTMLHeadingElement,
}) {
  connectedCallback () {
    super.connectedCallback()
    this.hasGiftingViewParam =
      this.params.has('gifting-view') &&
      this.params.get('gifting-view') === 'true'
    this.showView = this.hasGiftingViewParam

    if (this.title === 'false') return

    if (this.showView) {
      this.textContent = this.title
    }

    this.style.visibility = 'visible'

    if (this.externalEls.priceFilter && this.showView) {
      this.externalEls.priceFilter.element.style.display = 'block'
    }
  }

  get title () {
    return this.dataset.giftingTitle
  }

  get params () {
    return new URLSearchParams(window.location.search)
  }
}

if (!customElements.get('gifting-view')) {
  customElements.define('gifting-view', GiftingView, { extends: 'h1' })
}
